export default __webpack_public_path__ + "static/media/TF_02.a71e8ab3.png";